<template>
  <div class="widget" style="overflow: hidden">
    <div
      class="widget-header"
      :style="{ height: heightWidgetHeader, minHeight: heightWidgetHeader }"
    >
      <div class="widget-header__title vue-draggable-handle">
        <div class="left" :style="`width: calc(100% - ${isEventStaus ? 60 : 40}px)`">
          <div>
            <c-label
              style="width: initial"
              :weight="700"
              :size="16"
              :lineHeight="24"
              :color="$theme.COLOR.UI.UI13"
              :ellipsis="true"
              class="widget-header__title_title"
              >{{ title }}
            </c-label>
            <span v-if="info" class="no-drag">
              <lego-icon :iconType="'df'" :icon="'info'" :size="16" v-lego-tooltip="info" />
            </span>
          </div>
          <div class="sub-title" style="height: 21px" v-if="subTitle || addtxt">
            <span v-if="subTitle">
              <c-label
                :color="$theme.COLOR.UI.UI13"
                :ellipsis="true"
                class="widget-header__title_subtitle"
                style="display: block"
                >{{ subTitle }}</c-label
              >
            </span>
            <span v-if="addtxt">
              <c-label
                :color="$theme.COLOR.UI.UI06"
                :size="12"
                :ellipsis="true"
                class="widget-header__title_addtxt"
                >{{ addtxt }}</c-label
              >
            </span>
          </div>
        </div>

        <div class="no-drag" style="display: flex; position: absolute; right: 10px">
          <slot name="extra-action" />
          <div class="dropdown-group">
            <lego-drop-holder-item-icon
              v-if="isEventStaus"
              :btnIconType="'line'"
              :btnIconName="'download_small'"
              :isDropIcon="true"
              :submenuIcon="false"
              :dropdownData="$const.FILE_TYPE_EVENT_STATUS"
              :tooltip="$t('page.performance.download')"
              class="hoverActive"
              @click="saveFile($event, listEventStatus, searchDate)"
            >
            </lego-drop-holder-item-icon>
            <lego-icon
              v-else
              icon="download_small"
              icon-type="line"
              :size="16"
              @click="capture"
              class="hoverActive btn-download"
              v-lego-tooltip="$util.capitalize($t('label.download'))"
            ></lego-icon>
            <lego-drop-holder
              v-if="isCustomDashboard && !sharedDashboard"
              :items="ctrlItem"
              :menuDirection="'right'"
              :itemWidth="getLocale == 'en' ? 77 : 80"
              class="hoverActive"
              style="cursor: pointer"
              @click="onMoreClick"
            >
              <lego-icon :iconType="'df'" :icon="'more'" :size="16" />
            </lego-drop-holder>
          </div>
        </div>
      </div>
    </div>
    <slot name="date-range"></slot>
    <div
      class="widget-body"
      :style="{
        height: `calc(100% - ${heightWidgetHeader} - ${isExistDateRange ? dateRangeHeight : '0px'})`
      }"
    >
      <nullWidget
        v-if="empty"
        :minHeight="84"
        :iconSize="37"
        :fontSize="14"
        style="height: 100%"
        :errorMessage="errorMessage"
      />
      <template v-if="!empty">
        <slot></slot>
      </template>
    </div>

    <div
      v-show="loading"
      id="widget-loadingbar"
      class="vld-overlay is-active"
      style="
        position: absolute;
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        z-index: 10;
      "
    >
      <div
        class="vld-background"
        style="
          bottom: 0;
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0.4);
          opacity: 0.4;
        "
      ></div>
      <div class="vld-icon">
        <div class="s-loader">
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
            <g fill="none" fill-rule="evenodd">
              <g>
                <g>
                  <path
                    fill="#DDDEE0"
                    d="M30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0zm0 7C17.297 7 7 17.297 7 30s10.297 23 23 23 23-10.297 23-23S42.703 7 30 7z"
                    transform="translate(-231 -293) translate(231 293)"
                  ></path>
                  <path
                    fill="#364FC7"
                    d="M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7V0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30h7c0 12.703 10.297 23 23 23z"
                    transform="translate(-231 -293) translate(231 293)"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import { downloadEventStatusExcel as downloadExcel } from '@/containers/performance/productMetricLib.js';
import nullWidget from '@/containers/widget/components/NullWidget';
import widgetDownloadMixin from '@/containers/widget/components/widgetDownloadMixin';

import '@style/ui/uiDownloadChart.scss';
import { mapState } from 'vuex';

export default {
  name: 'widgetWrapperScpm',
  components: { nullWidget },
  mixins: [widgetDownloadMixin],
  emits: ['download', 'ctrl'],
  inject: ['isCustomDashboard', 'sharedDashboard', 'getErrorMessage', 'isSettingMode'],
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    defaultTitle: {
      type: String,
      default: ''
    },
    addtxt: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    dateItem: {
      type: String,
      default: ''
    },
    more: {
      type: [String, Object],
      default: ''
    },
    info: {
      type: String,
      default: ''
    },
    empty: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isTop5: {
      type: Boolean,
      default: false
    },
    dateRangeHeight: {
      type: String,
      default: '36px'
    },
    isEventStaus: {
      type: Boolean,
      default: false
    },
    listEventStatus: {
      type: Array,
      default: () => []
    },
    searchDate: {
      type: Object,
      default: () => {}
    },
    eventState: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      project: (state) => state.project.text
    }),
    errorMessage() {
      return this.getErrorMessage() === '' ? 'label.noData' : this.getErrorMessage();
    },
    heightWidgetHeader() {
      // when update height of defaultTitle then need update css of widget-header__title
      if (this.defaultTitle) return '44px';
      if (this.subTitle && this.title && this.addtxt) return '80px';
      return '60px';
    },
    isExistDateRange() {
      return this.$slots['date-range'];
    },
    getLocale() {
      const language = window.localStorage.getItem('language');
      if (language) return language.substring(0, 2);
      return 'en';
    }
  },
  data() {
    return {
      dropdownDataExport: [{ txt: 'PNG File' }],
      ctrlItem: [
        { value: 'modify', text: this.$t('page.dashboard.widgetEdit') },
        { value: 'copy', text: this.$t('page.dashboard.widgetCopy') },
        { value: 'delete', text: this.$t('page.dashboard.deleteWidget') }
      ]
    };
  },
  methods: {
    noDownloadData() {
      this.$modal.open({
        rootId: 'app',
        type: 'alert',
        title: this.$t('title.notice'),
        message: this.$t('message.noDownloadData'),

        action: () => {}
      });
    },
    capture() {
      if (this.empty) {
        this.noDownloadData();
        return;
      }
      if (this.isTop5) return this.$emit('download');
      const el = this.$parent.$el;
      el.classList.add('widget-custom');
      const nameDownload = this.title || this.defaultTitle;
      return this.downloadWidget(el, nameDownload);
    },
    onMoreClick(item) {
      this.$emit('ctrl', item.value);
    },
    saveFile(selItem, listEvents, searchPeriod) {
      if (!listEvents.length) this.noDownloadData();
      else {
        this.$modal.open({
          rootId: 'app',
          type: 'confirm',
          message: `<div>` + this.$t('page.performance.downloadCheck') + `</div>`,
          title: this.$t('title.notice'),
          action: () => {
            if (selItem.type === 'image') {
              this.capture();
            } else if (selItem.type === 'excel') {
              downloadExcel(
                listEvents,
                searchPeriod,
                this.isCustomDashboard,
                this.title,
                this.eventState
              );
            }
          },
          cancel: () => {}
        });
      }
    }
  }
};
</script>
<style lang="scss">
.dropdown-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.hoverActive {
  line-height: 24px;
}

.hoverActive.lego-drop-holder,
.hoverActive.lego-dropdown-check-wrap {
  display: none;
}

.hoverActive.btn-download {
  display: none;
}
</style>
<style scoped lang="scss">
.vld-overlay .s-loader {
  width: 60px;
  height: 60px;
  -webkit-animation: load8-data-v-ba7f16fe 1s infinite linear;
  animation: load8-data-v-ba7f16fe 1s infinite linear;
}

.widget {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  //border: 1px solid $color--ui08;
  border-radius: 4px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 8px 16px;
    display: inline;
    z-index: 2;

    :deep .opus-icon__info {
      margin-left: 8px;
      position: relative;
      top: 1px;
    }

    &__title {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      text-align: left;
      min-height: 28px;

      .left {
        display: flex;
        flex-direction: column;

        & > div:first-child {
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
        }
      }

      &_title {
        display: inline-block;
        text-align: left;
      }

      &_subtitle {
        display: inline;
        margin-right: 8px;
      }

      &_addtxt {
        display: inline;
      }
    }
  }

  &-body {
    flex: 1 1 auto;
    min-width: 0;
    padding: 0px 16px 16px;
    height: 100%;

    &::after {
      clear: both;
    }
  }
}
</style>
